import React from 'react';
import MuiFormLabel from '@material-ui/core/FormLabel';
import { withStyles } from '@material-ui/styles';
import PropTypes from 'prop-types';

const styles = theme => ({
  root: {
    fontSize: '0.875rem',
    color: theme.palette.secondary['900'],
    '&:hover': {
      color: theme.palette.secondary.text,
    },
  },
  focused: {
    color: theme.palette.secondary.text,
  },
  disabled: {
    color: theme.palette.gray.light,
  },
});


const FormLabel = (props) => {
  const {
    classes, children,
  } = props;

  return (
    <MuiFormLabel
      {...props}
      classes={{
        root: classes.root,
        focused: classes.focused,
        disabled: classes.disabled,
      }}
    >
      {children}
    </MuiFormLabel>
  );
};

FormLabel.propTypes = {
  children: PropTypes.element.isRequired,
  classes: PropTypes.shape({}).isRequired,
};


export default withStyles(styles)(FormLabel);
